import { userInfoSync } from 'hub-http/userInfo';
import memoize from 'react-utils/memoize';
import { logError } from './logError';
let memoizedScopesAsSet = memoize(() => {
  try {
    const scopes = userInfoSync().user.scopes;
    return new Set(scopes);
  } catch (e) {
    // eslint-disable-next-line no-console
    logError(new Error('userInfoSync failed in auth.ts when resolving scopes'));
    return new Set();
  }
});
export function isFriendsAndFamilyPortal() {
  try {
    return userInfoSync().portal.friends_and_family;
  } catch (e) {
    // eslint-disable-next-line no-console
    logError(new Error('userInfoSync failed in auth.ts when resolving isFriendsAndFamilyPortal)'));
    return false;
  }
}
export function hasScope(scope) {
  return memoizedScopesAsSet().has(scope);
}
export function resetMemoizedScopes() {
  memoizedScopesAsSet = memoize(() => {
    try {
      const scopes = userInfoSync().user.scopes;
      return new Set(scopes);
    } catch (e) {
      // eslint-disable-next-line no-console
      logError(new Error('userInfoSync failed in auth.ts when resolving scopes'));
      return new Set();
    }
  });
}
let memoizedGatesAsSet = memoize(() => {
  try {
    const gates = userInfoSync().gates;
    return new Set(gates);
  } catch (e) {
    // eslint-disable-next-line no-console
    logError(new Error('userInfoSync failed in auth.ts when resolving gates'));
    return new Set();
  }
});
export function hasGate(gateName) {
  return memoizedGatesAsSet().has(gateName);
}
export function getLimit(limitName) {
  try {
    return userInfoSync().portal.limits[limitName];
  } catch (e) {
    // eslint-disable-next-line no-console
    logError(new Error('userInfoSync failed in auth.ts when resolving limits'));
    return null;
  }
}
export const getMemoizedUserId = memoize(() => {
  try {
    return userInfoSync().user.user_id;
  } catch (e) {
    // eslint-disable-next-line no-console
    logError(new Error('userInfoSync failed in auth.ts when resolving user_id'));
    return null;
  }
});
export function resetMemoizedGates() {
  memoizedGatesAsSet = memoize(() => {
    try {
      const gates = userInfoSync().gates;
      return new Set(gates);
    } catch (e) {
      // eslint-disable-next-line no-console
      logError(new Error('userInfoSync failed in auth.ts when resolving gates'));
      return new Set();
    }
  });
}